Pegasus.CKEditableMixin = Em.Mixin.create({
  destroy: function(){
    this.destroyCK();
    this._super();
  },

  destroyCK: function(){
    $('.vr-ck-color-picker-wrapper').css('display', 'none');

    if ( CKEDITOR && CKEDITOR.instances ){
      Object.keys(CKEDITOR.instances).forEach(function(key){
        //if ( key === 'editor1' ){ return; }
        if ( CKEDITOR.instances[key].status !== 'ready' ) {
          CKEDITOR.instances[key].on('instanceReady', function(){
            CKEDITOR.instances[key].destroy(true);
          });
          return;
        }
        CKEDITOR.instances[key].destroy(true);
      });
    }
  },

  editableElement: function(){
    return $(window.vrChildWindow.vrChildWindow.document).find('#' + this.get('controller.textEditableId') );
  }.property().volatile(),

  launchTextEditor: function(){
    var self = this;
    import( 'ckeditor' ).then(function(){
      Em.run.next( self, 'launchTextEditorCallback' );
    });
  },

  launchTextEditorCallback: function(){
    var $elm = this.get('editableElement'),
      fontFamily = $elm.css('fontFamily'),
      fontSize = $elm.css('fontSize'),
      config = {
        enterMode: CKEDITOR.ENTER_DIV,
        sharedSpaces: {
          top: 'ck-top'
        },
        startupFocus: true,
        customConfig: CKEDITOR_CONFIGPATH,
        on: {
          change: function(ev) {
            var toolbar = Pegasus.lookupController('toolbar');
            Em.run(toolbar, 'send', 'didChangeText');
          },
          instanceReady: function(ev){
            $('#ck-top').css({
              zIndex: 3
            });
            $('.loader-mask').remove();
            $('.vr-ck-color-picker-wrapper').css('display', 'inline-block');

            // activate the tools so the functions will work externally
            CKEDITOR.tools.callFunction(9,this);
            CKEDITOR.tools.callFunction(12,this);
            CKEDITOR.tools.callFunction(12,this); //deactivated state
            // the above functions use setTimeout so we must as well
            Em.run.later( ev.editor, function(){
              try {
                if ( this.status === 'destroyed' ) { return; }
                this.focus();
              } catch (e) {}
            }, 500);

            Em.run.scheduleOnce('afterRender', this, function(){
              $('.cke_panel').css('marginTop', -1000);
            });

          }.bind(this),
          selectionChange: function(d){
            var hexs = [];
            d.data.path.elements.forEach(function(el){
              hexs.push( hexValuesInString( el.$.outerHTML ) );
            });
            hexs = hexs.flatten().uniq();
            var existing = Pegasus.lookupController('toolbar').get('userSelectedColors');
            Pegasus.lookupController('toolbar').set('userSelectedColors', existing.concat(hexs).flatten().uniq());
          }
        }
      };

    if ( ! this.$() ) { return; }

    // Fake the selected default font family
    if (fontFamily) {
      config.font_defaultLabel = fontFamily.split(/ *, */).shift().capitalize();
    }

    // Fake the selected default font size
    if (fontSize) {
      config.fontSize_defaultLabel = fontSize.replace(/[^0-9]/g, '');
    }

    var self = this;

    CKEDITOR.inline( $elm[0], config );
    CKEDITOR.instances[$elm[0].id].on('change', function(){
      Em.run.scheduleOnce('afterRender', this, function(){
        if ( CKEDITOR.instances && CKEDITOR.instances.editor1 ) {
          if ( CKEDITOR.instances.editor1.getData() !== this.getData()) {
              CKEDITOR.instances.editor1.setData(this.getData());
          }
        }
      });
    });
  }
});
